import { Badge } from '@mui/material';
import { ReactNode } from 'react';

interface IAccordionBadge {
  bgcolor: string;
  borderColor: string;
  children: ReactNode;
}

export const AccordionBadge = ({
  children,
  bgcolor,
  borderColor,
}: IAccordionBadge) => {
  return (
    <Badge
      sx={{
        border: '1px solid',
        bgcolor: bgcolor,
        borderColor: borderColor,
        borderRadius: '6px',
        padding: '0 12px 3px',
        width: 'fit-content',
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </Badge>
  );
};
